/*=====================================
    GameTempTransaction

    Author: Ac
    CreateTime: 2018 / 10 / 03
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoyRouterLazyLoadingView from 'components/commons/router/CupoyRouterLazyLoadingView';

/*--------------------------
    Styled
--------------------------*/

/*--------------------------
    Main Component
--------------------------*/
class GameTempTransaction extends Component {

    constructor(props) {
        super(props);

        const routerState = CupoyRouter.getCurrent();
        const { params, querys = {} } = routerState;

        const { gameid } = params;
        const { type } = querys;

        this.state = {
            gameid,
            type,
        };
    }

    componentDidMount() {

        const { gameid, type } = this.state;
        const gameSeverListById = this.props.gameSeverListById;
        const { cupoyStateReplace } = this.props.webActions;

        let stateName = type === 'purchase' ? 
            CupoyRouter.STATES.GAME_TRANSACTION_PURCHASE
            :
            CupoyRouter.STATES.GAME_TRANSACTION_SALE;

        if(!gameSeverListById || !gameSeverListById[gameid] || Object.keys(gameSeverListById[gameid]).length === 0){

            this.props.gameActions.getGameServerList({
                gameid: gameid,
            }).then((result) => {
                const serverid = result.resultMap.gameserverid0;

                this.setState({
                    success: true,
                }, () => {                   
                    cupoyStateReplace(stateName, {
                        gameid: gameid,
                        serverid: serverid,
                    });
                });
            });
        } else {
            const serverid = gameSeverListById[gameid][0].gameserverid;

            this.setState({
                success: true,
            }, () => {

                cupoyStateReplace(stateName, {
                    gameid: gameid,
                    serverid: serverid,
                });
            });
        }
    }

    render() {
        const { success } = this.state;
        return (
            !success ?
            <CupoyRouterLazyLoadingView />
            :
            null
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        gameSeverListById: state.game.gameSeverListById,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(GameTempTransaction);